import withStyles from '@material-ui/core/styles/withStyles'
import { green } from '@material-ui/core/colors'
import Button from '@material-ui/core/Button'

export const ValidationButton = withStyles(() => ({
  root: {
    color: 'white',
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
}))(Button)
